import { Spread } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

const getSpread = (state: RootState, spreadIndex: number): Spread | undefined =>
  state.design.designData?.spreads[spreadIndex];

export default getSpread;
